/** Nombre de mots (séquences non vides séparées par des espaces). */
export function countWords(text: string): number {
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;
}
